<template>
  <div class="main">
    <div class="content">
      <webheader></webheader>
      <div class="home-page  ">

        <video id="video"
               muted
               class="video-player"
               x5-video-player-type="h5"
               x-webkit-airplay="true"
               webkit-playsinline="true"
               playsinline=""
               preload="none"
               :poster='posterUrl'
               autoplay=""
               loop="">
          <source src="https://teamones-1302852381.cos.ap-shanghai.myqcloud.com/static/video/zAJotouWvo_ff69b52a02dae7bce3506f0e53a3d4a6/zAJotouWvo_ff69b52a02dae7bce3506f0e53a3d4a6.mp4"
                  type="video/mp4"
                  x5-video-player-type="h5"
                  x-webkit-airplay="true"
                  webkit-playsinline="true"
                  playsinline=""
                  poster=""
                  autoplay=""
                  preload="none"
                  loop="">
          <track kind="captions"></video>
      </div>
    </div>
    <div class="footer">
      <webfooter></webfooter>
    </div>
    <!-- <div class="footer">
      <tabfooter></tabfooter>
    </div> -->
  </div>
</template>

<script>
import webheader from '@/components/webheader'
import webfooter from '@/components/webfooter'
import tabfooter from '@/components/tabfooter'
export default {
  name: 'home',
  components: { webfooter, webheader, tabfooter },
  data () {
    return {
      isShow: true,
      // http://tuchuang.cgspread.com/sm_demo.mp4?vframe/jpg/offset/1
      posterUrl: require('../assets/sm_demo.png')
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.video-player {
  display: block;
  background: rgb(31, 35, 39);
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.footer {
  width: 100%;
  height: 14px;
  position: absolute;
  bottom: 20px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue